export default __webpack_public_path__ + "static/media/sponge-pointer.998f2c4c.png";